import { render } from "./Quote.vue?vue&type=template&id=cf2039a6&scoped=true"
import script from "../js/quote.js?vue&type=script&lang=js"
export * from "../js/quote.js?vue&type=script&lang=js"

import "./Quote.vue?vue&type=style&index=0&id=cf2039a6&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinumlandscapemi/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf2039a6"]])

export default __exports__